import { aiAssistantNavbar } from './prototypes/easm-platform/ai-assistant/ai-assistant.navbar';
import { AiAssistantRouteId } from './prototypes/easm-platform/ai-assistant/models/ai-assistant-route-id';
import { SolApp, SolNavbar, SolNavbarItem } from '@sol/components';
import { SolIcon } from '@sol/icons';
import { PrototypeRouteId } from './models/prototype-route-id';
import { billingNavbar } from './prototypes/billing/billing.navbar';
import { credentialsV2Navbar } from './prototypes/credentials-v2/credentials-v2.navbar';
import { cyberflexNavbar } from './prototypes/cyberflex/cyberflex.navbar';
import { assetInventoryNavbar } from './prototypes/asset-inventory/asset-inventory.navbar';
import { assetDetailsNavbar } from './prototypes/asset-details/asset-details.navbar';
import { engagementRequestsFinetuningNavbar } from './prototypes/engagement-requests-finetuning/engagement-requests-finetuning.navbar';
import { findingTemplatesNavbar } from './prototypes/finding-templates/finding-templates.navbar';
import { observationAttachmentsNavbar } from './prototypes/observation-attachments/observation-attachments.navbar';
import { legacyObservationAttachmentsNavbar } from './prototypes/legacy-observation-attachments/legacy-observation-attachments.navbar';
import { dev18073ComplianceNavbar } from './prototypes/dev-18073-compliance/dev-18073-compliance.navbar';
import { dev18689GhostlabMatchesNavbar } from './prototypes/dev-18689-ghostlab-matches/dev-18689-ghostlab-matches.navbar';
import { projectNorthStarNavbar } from './prototypes/easm-platform/project-north-star/project-north-star.navbar';
import { vulnerabilityCatalogNavbar } from './prototypes/vulnerability-catalog/vulnerability-catalog.navbar';
import { dashboardBannersNavbar } from './prototypes/easm-platform/dashboard-banners/dashboard-banners.navbar';
import { moduleReadOnlyBannerNavbar } from './prototypes/module-read-only-banner/module-read-only-banner.navbar';
import { findingVerificationFlowNavbar } from './prototypes/finding-verification-flow/finding-verification-flow.navbar';
import { redirectDuplicatesNavbar } from './prototypes/redirect-duplicates/redirect-duplicates.navbar';
import { threatExplorerNavbar } from './prototypes/threat-explorer/threat-explorer.navbar';
import { webcontentV2Navbar } from './prototypes/webcontent-v2/webcontent-v2.navbar';
import { workflowsNavbar } from './prototypes/workflows/workflows.navbar';
import { annotationNotesNavbar } from './prototypes/annotation-notes/annotation-notes.navbar';

import { subscopeHierarchyNavbar } from './prototypes/subscope-hierarchy/subscope-hierarchy.navbar';

const homeNavbar: SolNavbar = {
  menu: [
    SolNavbarItem.of(PrototypeRouteId.home, {
      displayName: 'Home',
      icon: SolIcon.application,
    }),
  ],
  system: [],
  account: [
    SolNavbarItem.of(PrototypeRouteId.account_section1, {
      children: [
        SolNavbarItem.of(PrototypeRouteId.account_preferences, {
          displayName: 'Preferences',
        }),
      ],
    }),
    SolNavbarItem.of(PrototypeRouteId.account_section2, {
      children: [
        SolNavbarItem.of(PrototypeRouteId.account_logout, {
          displayName: 'Logout',
        }),
      ],
    }),
  ],
};

export const apps: SolApp[] = [
  SolApp.ofInternal(PrototypeRouteId.app_prototype, 'Prototypes', SolIcon.application, 'Prototypes', homeNavbar, []),
  SolApp.ofInternal(PrototypeRouteId.app_billing, 'Billing', SolIcon.usage, 'Prototypes', billingNavbar, []),
  SolApp.ofInternal(
    PrototypeRouteId.app_credentials_v2,
    'Credentials v2',
    SolIcon.leaked_secrets,
    'Prototypes',
    credentialsV2Navbar,
    [],
  ),
  SolApp.ofInternal(PrototypeRouteId.app_cyberflex, 'Cyberflex', SolIcon.shield, 'Prototypes', cyberflexNavbar, []),
  SolApp.ofInternal(
    PrototypeRouteId.app_asset_inventory,
    'Asset Inventory',
    SolIcon.asm_assets,
    'Prototypes',
    assetInventoryNavbar,
    [],
  ),
  SolApp.ofInternal(
    PrototypeRouteId.app_dev_18073_compliance,
    'DEV-18073 Compliance',
    SolIcon.shield,
    'Prototypes',
    dev18073ComplianceNavbar,
    [],
  ),
  SolApp.ofInternal(
    PrototypeRouteId.app_engagement_requests_finetuning,
    'Engagement requests finetuning',
    SolIcon.shield,
    'Prototypes',
    engagementRequestsFinetuningNavbar,
    [],
  ),
  SolApp.ofInternal(
    PrototypeRouteId.app_finding_templates,
    'Findings',
    SolIcon.finding,
    'Prototypes',
    findingTemplatesNavbar,
    [],
  ),
  SolApp.ofInternal(
    PrototypeRouteId.app_observation_attachments,
    'Observation attachments',
    SolIcon.documents,
    'Prototypes',
    observationAttachmentsNavbar,
    [],
  ),
  SolApp.ofInternal(
    PrototypeRouteId.app_legacy_observation_attachments,
    'Observation attachments (dialog flow)',
    SolIcon.documents,
    'Prototypes',
    legacyObservationAttachmentsNavbar,
    [],
  ),
  SolApp.ofInternal(
    PrototypeRouteId.app_dev_18689_ghostlab_matches,
    'DEV-18689 Ghostlab matches',
    SolIcon.finding,
    'Prototypes',
    dev18689GhostlabMatchesNavbar,
    [],
  ),
  SolApp.ofInternal(
    PrototypeRouteId.app_project_north_star,
    'Integrated people view',
    SolIcon.users,
    'Prototypes',
    projectNorthStarNavbar,
    [],
  ),
  SolApp.ofInternal(
    PrototypeRouteId.app_annotation_notes,
    'Annotation notes',
    SolIcon.note,
    'Prototypes',
    annotationNotesNavbar,
    [],
  ),
  SolApp.ofInternal(
    PrototypeRouteId.app_redirect_duplicates,
    'Redirect duplicates',
    SolIcon.asm_tracker,
    'Prototypes',
    redirectDuplicatesNavbar,
    [],
  ),
  SolApp.ofInternal(
    PrototypeRouteId.app_vulnerability_catalog,
    'Vulnerability catalog',
    SolIcon.vulnerability,
    'Prototypes',
    vulnerabilityCatalogNavbar,
    [],
  ),
  SolApp.ofInternal(
    PrototypeRouteId.app_dashboard_banners,
    'Dashboard banners',
    SolIcon.notification,
    'Prototypes',
    dashboardBannersNavbar,
    [],
  ),
  SolApp.ofInternal(
    PrototypeRouteId.app_module_read_only_banner,
    'Module read-only banner',
    SolIcon.lock,
    'Prototypes',
    moduleReadOnlyBannerNavbar,
    [],
  ),
  SolApp.ofInternal(
    PrototypeRouteId.app_finding_verification_flow,
    'Finding verification flow',
    SolIcon.finding,
    'Prototypes',
    findingVerificationFlowNavbar,
    [],
  ),
  SolApp.ofInternal(
    PrototypeRouteId.app_threat_explorer,
    'Threat Explorer',
    SolIcon.radar,
    'Prototypes',
    threatExplorerNavbar,
    [],
  ),
  SolApp.ofInternal(
    PrototypeRouteId.app_subscope_hierarchy,
    'Subscope hierarchy',
    SolIcon.sub_scope,
    'Prototypes',
    subscopeHierarchyNavbar,
    [],
  ),
  SolApp.ofInternal(AiAssistantRouteId.app, 'AI assistant', SolIcon.radar, 'Prototypes', aiAssistantNavbar, []),
  SolApp.ofInternal(
    PrototypeRouteId.app_asset_details,
    'Asset details',
    SolIcon.asm_assets,
    'Prototypes',
    assetDetailsNavbar,
    [],
  ),
  SolApp.ofInternal(
    PrototypeRouteId.app_webcontent_v2,
    'Web Content v2',
    SolIcon.asm_dark_web,
    'Prototypes',
    webcontentV2Navbar,
    [],
  ),
  SolApp.ofInternal(PrototypeRouteId.app_workflows, 'Workflows', SolIcon.workflow, 'Prototypes', workflowsNavbar, []),
];
